<script setup lang="ts">

import { FilterDateRange, FiltersBar } from '@shared/ui/filters'
import { AppInput } from '@shared/ui/inputs'

import { useTasksKanbanLogFilters } from '../model/tasks-kanban-log-filters.hook'

defineOptions({
  name: 'TasksKanbanLogFilters',
})

const {
  filterResetKey,
  searchQuery,
  dateRange,
  handleSearch,
  handleClear,
} = useTasksKanbanLogFilters()
</script>

<template>
  <FiltersBar
    class="tasks-kanban-log-filters"
    @click:submit="handleSearch"
    @click:clear="handleClear"
  >
    <template #fields>
      <div
        :key="filterResetKey"
        class="tasks-kanban-log-filters__general"
      >
        <AppInput
          v-model="searchQuery"
          label="Search"
          placeholder="Type here"
        />
        <FilterDateRange
          v-model="dateRange"
          label="Date"
          placeholder="Type here"
        />
      </div>
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./TasksKanbanLogFilters.scss" />